export const lang = {
	"发布公告": '发布公告',
	"公告标题": '公告标题',
	"启用":'启用',
	"停用": "停用",
	"状态": "状态",
	"发布对象": "发布对象",
	"供应商": "供应商",
	"站长": "站长",
	"创建时间": "创建时间",
	"操作": "操作",
	"编辑": "编辑",
	"删除": "删除",
	"站长(分销商)": "站长(分销商)",
	"发布内容": "发布内容",
	"取消发布": "取消发布",
	"确定发布": "确定发布",
	"编辑公告描述": "编辑公告描述",
	"图片大小不能超过": "图片大小不能超过",
	"不能识别此文件": "不能识别此文件",
}
